var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Checkbox, Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { pluck } from 'ramda';
import { Button } from 'ui/styled';
import { StyledSearch } from 'ui/styled/Inputs';
import { useChatTemplatesQuery } from 'apollo/queries/CHAT_TEMPLATES';
import { useTeamChatTemplatesQuery } from 'apollo/queries/Teams/TEAM_CHAT_TEMPLATES';
import useTeamUpdateChatTemplatesMutation from 'apollo/mutations/Teams/TEAM_UPDATE_CHAT_TEMPLATES';
import { calculateFlagChanges } from './helpers';
import { OptionsWrapper, StickyFooter } from './styled';
var ChatTemplates = function () {
    var _a, _b, _c;
    var id = useParams().id;
    var _d = useState([]), initialTemplates = _d[0], setInitialTemplates = _d[1];
    var _e = useState([]), selectedTemplates = _e[0], setSelectedTemplates = _e[1];
    var _f = useState(''), search = _f[0], setSearch = _f[1];
    var _g = useTeamUpdateChatTemplatesMutation(), onUpdateChatTemplates = _g.onMutate, updateLoading = _g.loading;
    var _h = useChatTemplatesQuery(), templatesData = _h.data, templatesLoading = _h.loading;
    var _j = useTeamChatTemplatesQuery({
        variables: { id: id },
        skip: !id
    }), teamData = _j.data, teamLoading = _j.loading;
    var templates = ((_b = (_a = templatesData === null || templatesData === void 0 ? void 0 : templatesData.chat_templates) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : []).flatMap(function (template) { return (template ? [template] : []); });
    var teamTemplates = (_c = teamData === null || teamData === void 0 ? void 0 : teamData.team) === null || _c === void 0 ? void 0 : _c.chat_templates;
    useEffect(function () {
        var initTemplates = teamTemplates ? pluck('id', teamTemplates) : [];
        setInitialTemplates(initTemplates);
        setSelectedTemplates(initTemplates);
    }, [teamTemplates]);
    var _k = calculateFlagChanges(initialTemplates, selectedTemplates), add_ids = _k.add_ids, remove_ids = _k.remove_ids, totalChangesCount = _k.totalChangesCount;
    var query = search.trim().toLowerCase();
    var filteredTemplates = query
        ? templates.filter(function (template) { return template.title.toLowerCase().includes(query); })
        : templates;
    var onFinish = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isErrorFree;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onUpdateChatTemplates({
                        team_id: id,
                        add_ids: add_ids,
                        remove_ids: remove_ids
                    })];
                case 1:
                    isErrorFree = (_a.sent()).isErrorFree;
                    if (isErrorFree)
                        setInitialTemplates(selectedTemplates);
                    return [2 /*return*/];
            }
        });
    }); };
    var showSpinner = templatesLoading || teamLoading || updateLoading;
    return (_jsxs(Spin, { spinning: showSpinner, children: [_jsxs("div", { style: { display: 'flex', gap: 8, marginBottom: 8 }, children: [_jsx(StyledSearch, { placeholder: "Search chat templates...", allowClear: true, value: search, onChange: function (e) { return setSearch(e.target.value); }, width: "300px" }), _jsx(Button, { onClick: function () { return setSelectedTemplates(pluck('id', filteredTemplates)); }, children: "Select all" }), _jsx(Button, { onClick: function () {
                            var filteredIds = pluck('id', filteredTemplates);
                            setSelectedTemplates(function (prev) {
                                return prev.filter(function (templateId) { return !filteredIds.includes(templateId); });
                            });
                        }, children: "Clear all" })] }), _jsx(Checkbox.Group, { value: selectedTemplates, onChange: function (values) { return setSelectedTemplates(values); }, children: _jsx(OptionsWrapper, { children: filteredTemplates.map(function (template) { return (_jsx(Checkbox, { value: template.id, children: template.title }, template.id)); }) }) }), _jsx(StickyFooter, { children: _jsx(Button, { btntype: "primary", onClick: onFinish, loading: updateLoading, disabled: showSpinner || totalChangesCount === 0, children: "Save" }) })] }));
};
export default ChatTemplates;
